import type { Nullable } from '@iheartjane/types';
import capitalize from 'lodash-es/capitalize';
import startCase from 'lodash-es/startCase';

import type { ComplianceLanguage } from '@jane/bloom/types/schemas/roots/complianceLanguage';

export function getSpecialType(
  specialType: string,
  complianceLanguage?: Nullable<ComplianceLanguage>
) {
  if (specialType === 'bundle') {
    return capitalize(complianceLanguage?.['bundle'] || '') || 'Bundle';
  }

  return startCase(specialType);
}
